import type { FieldPath, FieldValues } from "react-hook-form";
import {
  CdcTextInputField,
  type CdcTextInputFieldProps,
} from "./cdc-field-helpers";

export type CdcLastNameFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
  CdcTextInputFieldProps<TFieldValues, TName>,
  "autoComplete" | "fieldKey" | "inputMode" | "maxLength" | "pattern" | "type"
>;

export function CdcLastNameField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  required = false,
  ...props
}: Readonly<CdcLastNameFieldProps<TFieldValues, TName>>) {
  return (
    <CdcTextInputField
      {...props}
      autoComplete="family-name"
      fieldKey="lastName"
      required={required}
      type="text"
    />
  );
}
